import axiosConfig from "./axiosConfig";

export interface CurveToSplit {
  label: string;
  config: Record<string, unknown>;
}

export interface SplitIntoCurvesRequest {
  curves: CurveToSplit[];
  deleteSource?: boolean;
}

export interface SplitNewGuid {
  label: string;
  fileGuid: string;
  operationKey: string;
}

export interface SplitFailure {
  label: string;
  error: string;
}

export interface SplitIntoCurvesResponse {
  newGuids: SplitNewGuid[];
  failed: SplitFailure[];
}

const postHhDataTempSplitIntoCurves = async (
  authToken: string,
  fileGuid: string,
  request: SplitIntoCurvesRequest
): Promise<SplitIntoCurvesResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/split_into_curves`,
    request,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postHhDataTempSplitIntoCurves;
